import PlaceholderLoader from './placeholderLoader';

export default PlaceholderLoader;
